import React from 'react';
import StartModal from './StartModal';

const ArchivedBoardModal = ({ boardNum, onStart, onClose, difficulty }) => (
    <StartModal title={`Board #${boardNum}`} difficulty={difficulty} onStart={onStart} onClose={onClose} archived>
        <div className='archived-board-timer-text'>
            The timer starts when you press <strong>Start</strong>.
        </div>
    </StartModal>
);

export default ArchivedBoardModal;
